/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "transfer_common": {
                "nested": {
                  "TransferClientCapableFlow": {
                    "fields": {
                      "linkBankAccount": {
                        "type": "squareup.bbfrontend.common.transfer_common.TransferClientCapableFlow.LinkBankAccount",
                        "id": 1
                      },
                      "linkDebitCard": {
                        "type": "squareup.bbfrontend.common.transfer_common.TransferClientCapableFlow.LinkDebitCard",
                        "id": 2
                      },
                      "instantTransferLinkBankAccount": {
                        "type": "squareup.bbfrontend.common.transfer_common.TransferClientCapableFlow.InstantTransferLinkBankAccount",
                        "id": 3
                      }
                    },
                    "nested": {
                      "LinkBankAccount": {
                        "fields": {}
                      },
                      "LinkDebitCard": {
                        "fields": {}
                      },
                      "InstantTransferLinkBankAccount": {
                        "fields": {
                          "flow": {
                            "type": "squareup.bbfrontend.common.transfer_common.TransferClientCapableFlow.InstantTransferLinkBankAccount.Flow",
                            "id": 1,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Flow": {
                            "values": {
                              "DO_NOT_USE_FLOW": 0,
                              "FULL_SETUP": 1,
                              "CHANGE_BANK_ACCOUNT_NO_DEBIT_CARD": 2,
                              "CHANGE_BANK_ACCOUNT_WITH_DEBIT_CARD": 3,
                              "ADD_BANK_ACCOUNT": 4
                            }
                          }
                        }
                      },
                      "value": {
                        "oneof": ["linkBankAccount", "linkDebitCard", "instantTransferLinkBankAccount"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferClientCapableFlow && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferClientCapableFlow?.nested?.LinkBankAccount && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferClientCapableFlow?.nested?.LinkDebitCard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferClientCapableFlow?.nested?.InstantTransferLinkBankAccount && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.transfer_common?.nested?.TransferClientCapableFlow?.nested?.InstantTransferLinkBankAccount?.nested?.Flow) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE TransferClientCapableFlow @ squareup/bbfrontend/common/transfer_common/client_capable_flow.proto at 11:1
 */
export const TransferClientCapableFlow = $root.lookupType('squareup.bbfrontend.common.transfer_common.TransferClientCapableFlow');
fixType(TransferClientCapableFlow);
Builder.createAndAttachToType(TransferClientCapableFlow);
/**
 * SOURCE LinkBankAccount @ squareup/bbfrontend/common/transfer_common/client_capable_flow.proto at 12:3
 */
TransferClientCapableFlow.LinkBankAccount = $root.lookupType('squareup.bbfrontend.common.transfer_common.TransferClientCapableFlow.LinkBankAccount');
fixType(TransferClientCapableFlow.LinkBankAccount);
Builder.createAndAttachToType(TransferClientCapableFlow.LinkBankAccount);
/**
 * SOURCE LinkDebitCard @ squareup/bbfrontend/common/transfer_common/client_capable_flow.proto at 13:3
 */
TransferClientCapableFlow.LinkDebitCard = $root.lookupType('squareup.bbfrontend.common.transfer_common.TransferClientCapableFlow.LinkDebitCard');
fixType(TransferClientCapableFlow.LinkDebitCard);
Builder.createAndAttachToType(TransferClientCapableFlow.LinkDebitCard);
/**
 * SOURCE InstantTransferLinkBankAccount @ squareup/bbfrontend/common/transfer_common/client_capable_flow.proto at 15:3
 */
TransferClientCapableFlow.InstantTransferLinkBankAccount = $root.lookupType('squareup.bbfrontend.common.transfer_common.TransferClientCapableFlow.InstantTransferLinkBankAccount');
fixType(TransferClientCapableFlow.InstantTransferLinkBankAccount, {
  flow: {
    required: true
  }
});
Builder.createAndAttachToType(TransferClientCapableFlow.InstantTransferLinkBankAccount);
/**
 * SOURCE Flow @ squareup/bbfrontend/common/transfer_common/client_capable_flow.proto at 16:5
 */
TransferClientCapableFlow.InstantTransferLinkBankAccount.Flow = $root.lookupEnum('squareup.bbfrontend.common.transfer_common.TransferClientCapableFlow.InstantTransferLinkBankAccount.Flow').values;